import { useEffect } from "react";
import { Printer } from "lucide-react";
import { Nice, niceText } from "@/components/Nice";

export default function PrintNote() {
  const note = localStorage.getItem("pp_last_note") || "";
  useEffect(() => { if (note) { const t = setTimeout(() => window.print(), 500); return () => clearTimeout(t); } }, [note]);

  return (
    <div className="pp-dcards" data-testid="print-note-page">
      <div className="pp-dcards-bar no-print">
        <p>Print it on nice paper, or copy it onto a card in your best handwriting.</p>
        <button className="pp-primary" onClick={() => window.print()} data-testid="print-note-page-button"><Printer className="h-5 w-5" /> Print</button>
      </div>
      <div className="pp-note-sheet">
        <article className="pp-note-card" data-testid="print-note-card">
          <img src="/acorn-t.png" alt="" />
          <p data-testid="print-note-text">{note || niceText("Write a thank-you note in NICE first, then print it here.")}</p>
          <footer>Written with <Nice />™ · A Colorful Acorn Parenting™ Resource · BurrHaus Counseling</footer>
        </article>
      </div>
    </div>
  );
}
